import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import DoubleArrowOutlinedIcon from '@mui/icons-material/DoubleArrowOutlined';
import { cartSelector } from '../../../store/user/user.selector';
import CartCard from '../../../components/Card/CartCard';
import './cart.scss';

const CartList = () => {
  const cart = useSelector(cartSelector);
  const [toSlice, setToSlice] = useState(2);

  const GoToTop = () => {
    // @ts-ignore
    document.getElementById('#cart').scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (!cart && !Array.isArray(cart)) return;

  return (
    <Box className='mainCartListContainer' id='#cart'>
      {cart?.slice(0, toSlice).map((item) => (
        <CartCard key={item.id} product={item} />
      ))}

      {cart?.length > 2 && (
        <Box
          className='moreContainer'
          onClick={() => {
            if (toSlice === 2) setToSlice(cart.length);
            else {
              setToSlice(2);
              GoToTop();
            }
          }}
        >
          <Typography fontSize='small' color='primary.main'>
            {toSlice === 2 ? ' مشهاده بیشتر' : ' مشهاده کمتر'}
          </Typography>
          <DoubleArrowOutlinedIcon
            color='primary'
            fontSize='small'
            sx={{ transform: toSlice === 2 ? 'rotate(90deg)' : 'rotate(-90deg)' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default CartList;
